import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import TooltipLabel from '../common/TooltipLabel/TooltipLabel';
import Tooltips from '../../config/Tooltips';
import ExtraDetail from '../../config/ExtraDetail';


const SOFTWARE = "SOFTWARE"
const HARDWARE = "HARDWARE"

class CurrentVersion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            extraDetail:ExtraDetail,
            tooltips:Tooltips
          };
    }


    render() {
        const {category, details} = this.props;

        const assetDetail = (category === SOFTWARE
            ? <div id="software-section">
                    <h3 id="software-details" className='detail-header'>SOFTWARE DETAILS</h3>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.software[0]} id="tooltip-title" />
                        <Col className="detail-text" id="title" xs="4">{details.title}</Col>
                    </Row>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.software[1]} id="tooltip-version" />
                        <Col className="detail-text" id="version" xs="4">{details.version}</Col>
                    </Row>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.software[2]} id="tooltip-version-group" />
                        <Col className="detail-text" id="version" xs="4">{details.version_group}</Col>
                    </Row>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.software[3]} id="tooltip-edition" />
                        <Col className="detail-text" id="edition" xs="4">{details.edition
                                ? details.edition
                                : "N/A"}</Col>
                    </Row>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.software[4]} id="tooltip-category" />
                        <Col className="detail-text" id="category" xs="4">{details.category}</Col>
                    </Row>
                    <Row>
                        <Col className="detail-text pt-3" xs="12">
                            <p id="other-versions"><i>The full version of Technopedia includes <strong>{details.version_order -1}</strong> other versions of this product.</i></p>
                        </Col>
                    </Row>
                    <h3 id="lifecycle-details" className='detail-header'>LIFECYCLE AND SUPPORT</h3>
                    {this.state.extraDetail.software.lifecycle.map((item, index) => (
                        <Row key={index}>
                            <TooltipLabel item={item} id={`lifecycle-tooltip-${index}`}/>
                            <Col className="detail-text" id="lifecycle" xs="4">
                                <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                            </Col>
                        </Row>
                    ))}
                    <h3 id="window-details" className='detail-header'>WINDOWS COMPATIBILITY</h3>
                    <h3 id="win10-details" className='detail-header'>WINDOWS 10 COMPATIBILITY</h3>
                    {this.state.extraDetail.software.windows10.map((item, index) => (
                        <Row key={index}>
                            <TooltipLabel item={item} id={`windows10-tooltip-${index}`}/>
                            <Col className="detail-text" id="windows10" xs="4">
                                <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                            </Col>
                        </Row>
                    ))}
                    <h3 id="win8-details" className='detail-header'>WINDOWS 8 COMPATIBILITY</h3>
                    {this.state.extraDetail.software.windows8.map((item, index) => (
                        <Row key={index}>
                            <TooltipLabel item={item} id={`windows8-tooltip-${index}`}/>
                            <Col className="detail-text" id="windows8" xs="4">
                                <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                            </Col>
                        </Row>
                    ))}
                    <h3 id="win7-details"  className='detail-header'>WINDOWS 7 COMPATIBILITY</h3>
                    {this.state.extraDetail.software.windows7.map((item, index) => (
                        <Row key={index}>
                            <TooltipLabel item={item} id={`windows7-tooltip-${index}`}/>
                            <Col className="detail-text" id="window7" xs="4">
                                <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                            </Col>
                        </Row>
                    ))}
                    <h3 id="dos-details" className='detail-header'>DEJASOURCE OPEN SOURCE</h3>
                    {this.state.extraDetail.software.dos.map((item, index) => (
                        <Row key={index}>
                            <TooltipLabel item={item} id={`dos-tooltip-${index}`}/>
                            <Col className="detail-text" id="dos" xs="4">
                                <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                            </Col>
                        </Row>
                    ))}
                    <h3 id="infoSec-details" className='detail-header'>INFOSEC</h3>
                    {this.state.extraDetail.software.infoSec.map((item, index) => (
                        <Row key={index}>
                            <TooltipLabel item={item} id={`infoSec-tooltip-${index}`}/>
                            <Col className="detail-text" id="infoSec" xs="4">
                                <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                            </Col>
                        </Row>
                    ))}
                    <h3 id="cve-details" className='detail-header'>COMMON VULNERABILITIES AND EXPOSURE(S)(CVE)</h3>
                    {this.state.extraDetail.software.cve.map((item, index) => (
                        <Row key={index}>
                            <TooltipLabel item={item} id={`cve-tooltip-${index}`}/>
                            <Col className="detail-text" id="cve" xs="4">
                                <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                            </Col>
                        </Row>
                    ))}
                </div>
            : category === HARDWARE
                ? <div id="hardware-section">
                        <h3 id="hardware-details" className='detail-header'>HARDWARE DETAILS</h3>
                        <Row>
                            <TooltipLabel item={this.state.tooltips.hardware[0]} id="tooltip-hardware-title" />
                            <Col className="detail-text" id="title" xs="4">{details.title}</Col>
                        </Row>
                        <Row>
                            <TooltipLabel item={this.state.tooltips.hardware[1]} id="tooltip-model" />
                            <Col className="detail-text" id="model" xs="4">{details.model
                                    ? details.model
                                    : "N/A"}</Col>
                        </Row>
                        <Row>
                            <TooltipLabel item={this.state.tooltips.hardware[2]} id="tooltip-profile" />
                            <Col className="detail-text" id="profile" xs="4">{details.profile
                                    ? details.profile
                                    : "N/A"}</Col>
                        </Row>
                        <Row>
                            <TooltipLabel item={this.state.tooltips.hardware[3]} id="tooltip-hardware-category" />
                            <Col className="detail-text" id="category" xs="4">{details.category}</Col>
                        </Row>

                        <h3 id="lifecycle-details" className='detail-header'>LIFECYCLE AND SUPPORT</h3>
                        {this.state.extraDetail.hardware.lifecycle.map((item, index) => (
                            <Row key={index}>
                                <TooltipLabel item={item} id={`lifecycle-tooltip-${index}`}/>
                                <Col className="detail-text" id='lifecycle' xs="4">
                                    <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                                </Col>
                            </Row>
                        ))}
                        <h3 id="specs-details" className='detail-header'>HARDWARE SPECIFICATIONS</h3>
                        {this.state.extraDetail.hardware.specs.map((item, index) => (
                            <Row key={index}>
                                <TooltipLabel item={item} id={`specs-tooltip-${index}`}/>
                                <Col className="detail-text" id="specs" xs="4">
                                    <a href={item.link} title={item.linkDes} target="_blank" rel="noopener noreferrer">Contact Us</a>
                                </Col>
                            </Row>
                        ))}
                    </div>
                : <div id="cpu-section">
                    <h3 id="cpu-details" className='detail-header'>CPU DETAILS</h3>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.cpu[0]} id="tooltip-model" />
                        <Col className="detail-text" id="model" xs="4">{details.model
                                ? details.model
                                : "N/A"}</Col>
                    </Row>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.cpu[1]} id="tooltip-cores" />
                        <Col className="detail-text" id="cores" xs="4">{details.cores}</Col>
                    </Row>
                    <Row>
                        <TooltipLabel item={this.state.tooltips.cpu[2]} id="tooltip-clock-rate" />
                        <Col className="detail-text" id="clock-rate" xs="4">{details.clock_rate}</Col>
                    </Row>
                </div>);

        return (
            <div>
            <Container fluid>
                {assetDetail}
            </Container>
        </div>
        );
    }

}


CurrentVersion.propTypes = {
    category: PropTypes.string,
    details: PropTypes.object
}

export default CurrentVersion;



// WEBPACK FOOTER //
// ./src/components/CurrentVersion/CurrentVersion.js